import DefaultCell from "application/components/DefaultCell";
import FsVoicePickerPlayAudio from "application/components/fsVoicePickerPlayAudio";
import FsVoicePickerFileDownload from "application/components/fsVoicePickerFileDownload";

const Attributes = {
  enableAdvanceSearch: true,
  enableUpdateTableRecords: false,
  enableDownloadButton: false,
  enableDownloadAllButton: false,
  enableDownloadPdf: false,
  modes: [],
};

const operationURLS = {
  list: "/fsVoicePicker/list",
};

const getColumns = () => {
  return [
    {
      Header: "Extension",
      accessor: "extension",
      displayInList: false,
      allowFilter: true,
      allowInForm: true,
      dataType: "string",
      filterControlType: "extension",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Location",
      accessor: "location",
      displayInList: true,
      allowFilter: false,
      allowInForm: false,
      dataType: "string",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Caller",
      accessor: "caller",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      dataType: "string",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Destination",
      accessor: "destinationNumber",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      dataType: "string",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Direction",
      accessor: "direction",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      dataType: "string",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Date Time",
      accessor: "dateTime",
      displayInList: true,
      allowFilter: true,
      allowInForm: true,
      dataType: "date",
      dateTime: true,
      Cell: ({ row, value }) => {
        if (!value) return <DefaultCell row={row} value={value} />;
        const formatted = new Date(value.replace(" ", "T")).toLocaleString();
        return <DefaultCell row={row} value={formatted} />;
      },
    },
    {
      Header: "File Name",
      accessor: "fileName",
      displayInList: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "File Size",
      accessor: "fileSize",
      displayInList: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ row, value }) => <DefaultCell row={row} value={value} />,
    },
    {
      Header: "Play",
      accessor: "id",
      displayInList: true,
      Cell: ({ row, value }) => (
        <FsVoicePickerPlayAudio row={row} value={value} />
      ),
    },
    {
      Header: "Download File",
      accessor: "",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      allowInForm: false,
      Cell: ({ row, value }) => (
        <FsVoicePickerFileDownload row={row} value={value} />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
